import firebase from "firebase/app";
/*
 * useFirebaseFunction
 *
 * Returns a type-aware function that calls the firebase function under the hood.
 * The first time this hook is used in a session it issues a warm-up request to
 * mitigate the Firebase function cold-start issue.
 * For obvious reasons, this should only be used with firebase functions that
 * support the warm-up protocol ({ warmUp: true }).
 */
const cachedFunctions = new Map();
export function getFirebaseFunction(name) {
    let callableFunction = cachedFunctions.get(name);
    if (!callableFunction) {
        callableFunction = firebase.functions().httpsCallable(name);
        cachedFunctions.set(name, callableFunction);
        // issue warm-up request
        callableFunction({ warmUp: true });
    }
    return callableFunction;
}
export function useFirebaseFunction(name) {
    return getFirebaseFunction(name);
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidXNlLWZpcmViYXNlLWZ1bmN0aW9uLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vc3JjL2hvb2tzL3VzZS1maXJlYmFzZS1mdW5jdGlvbi50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxPQUFPLFFBQVEsTUFBTSxjQUFjLENBQUM7QUFFcEM7Ozs7Ozs7O0dBUUc7QUFDSCxNQUFNLGVBQWUsR0FBRyxJQUFJLEdBQUcsRUFBNEMsQ0FBQztBQUU1RSxNQUFNLFVBQVUsbUJBQW1CLENBQUksSUFBWTtJQUNqRCxJQUFJLGdCQUFnQixHQUFHLGVBQWUsQ0FBQyxHQUFHLENBQUMsSUFBSSxDQUFDLENBQUM7SUFDakQsSUFBSSxDQUFDLGdCQUFnQixFQUFFLENBQUM7UUFDdEIsZ0JBQWdCLEdBQUcsUUFBUSxDQUFDLFNBQVMsRUFBRSxDQUFDLGFBQWEsQ0FBQyxJQUFJLENBQUMsQ0FBQztRQUM1RCxlQUFlLENBQUMsR0FBRyxDQUFDLElBQUksRUFBRSxnQkFBZ0IsQ0FBQyxDQUFDO1FBQzVDLHdCQUF3QjtRQUN4QixnQkFBZ0IsQ0FBQyxFQUFFLE1BQU0sRUFBRSxJQUFJLEVBQUUsQ0FBQyxDQUFDO0lBQ3JDLENBQUM7SUFDRCxPQUFPLGdCQUFrRixDQUFDO0FBQzVGLENBQUM7QUFFRCxNQUFNLFVBQVUsbUJBQW1CLENBQUksSUFBWTtJQUNqRCxPQUFPLG1CQUFtQixDQUFJLElBQUksQ0FBQyxDQUFDO0FBQ3RDLENBQUMifQ==